<template>
  <p-container>
    <p-row>
      <p-row>
        <p-col xs12 md6 lg5 xl3>
          <p-card fill-height>
            <h4>{{ $t('core.page.appLog.page.title') }}</h4>
            <span class="mt-3 mx-3">
              {{ $t('core.page.appLog.page.information') }}
            </span>
            <p-row align-end>
              <p-col justify-end>
                <router-link :to="`/_admin/applog?level=error&datefrom=${dateNow}`" tag="p-button">
                  {{ $t('core.page.appLog.page.button') }}
                </router-link>
              </p-col>
            </p-row>
          </p-card>
        </p-col>
        <p-col xs12 md6 lg5 xl3>
          <p-card fill-height>
            <h4>{{ $t('core.page.user.page.title') }}</h4>
            <span class="mt-3 mx-3">
              {{ $t('core.page.user.page.information') }}
            </span>
            <p-row align-end>
              <p-col justify-end>
                <router-link to="/_admin/users" tag="p-button">
                  {{ $t('core.page.user.page.button') }}
                </router-link>
              </p-col>
            </p-row>
          </p-card>
        </p-col>
      </p-row>
      <p-col md12 lg6>
        <p-card fill-height>
          <h4>{{ $t('core.page.health.page.title') }}</h4>
          <p-container>
            <p-progress-linear v-if="isLoading" indeterminate></p-progress-linear>
            <p-request-alert v-model="healthError" :dismissable="false"></p-request-alert>
            <template v-if="appHealth">
              <p v-if="appAbout" class="caption-1">
                {{ appAbout.title }} - {{ appAbout.environment }}
              </p>
              <p-table dense>
                <template #rows>
                  <tr v-for="(component, i) in appHealth.checks" :key="i">
                    <td>{{ component.component }}</td>
                    <td v-if="component.status.toLowerCase() === 'healthy'" class="text-color-success">
                      {{ $t('core.page.health.page.healthy') }}
                    </td>
                    <td v-else class="text-color-error">
                      {{ $t('core.page.health.page.unHealthy') }}
                    </td>
                    <td>{{ component.description }}</td>
                  </tr>
                </template>
              </p-table>
            </template>
          </p-container>
        </p-card>
      </p-col>
      <p-col xs12 md6 lg4>
        <p-card>
          <p-container>
            <p-row>
              <p-col xs12 xl6>
                <p-img contain width="100%" :src="require('../../../assets/glit-logo.png')"></p-img>
              </p-col>
              <p-col xs12 xl6 class="pl-3">
                <p-row column dense>
                  <span>Tel: <a href="tel:+41556145280">+41 55 614 52 80</a></span>
                  <span>Web: <a href="http://www.gl-it.ch" target="_blank">www.gl-it.ch</a></span>
                  <span>Email: <a href="mailto:info@gl-it.ch">info@gl-it.ch</a></span>
                </p-row>
                <p-divider class="my-4"></p-divider>
                <p-row column dense>
                  <span>gl it gmbh</span>
                  <span>Kerenzerbergstrasse 48</span>
                  <span>8758 Obstalden (GL)</span>
                </p-row>
              </p-col>
            </p-row>
          </p-container>
        </p-card>
      </p-col>
    </p-row>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';
  import ServiceResponse from '../../../plugins/servicelayer/responseTypes/serviceResponse';

  export default Vue.extend({
    auth: true,
    role: ['admin', 'hostadmin'],
    layout: 'layout-hostadmin',
    data: () => ({
      isLoading: false,
      healthError: undefined as any,
      aboutError: undefined as any,
      appAbout: undefined as any,
      appHealth: undefined as any,
      appLogs: undefined as any,
    }),
    computed: {
      isHostAdmin() {
        return this.$auth.isInRole('HostAdmin');
      },
      dateNow() {
        return Vue.$date.now().format('YYYY-MM-DD');
      },
    },
    async mounted() {
      this.loadHealth();
      this.loadAbout();
    },
    methods: {
      async loadHealth() {
        this.isLoading = true;
        try {
          const response = await this.$service.api.core.app.getHealth();
          this.appHealth = response.data;
        } catch (e) {
          const errorResponse = e as ServiceResponse;
          if (errorResponse?.status === 503) {
            this.appHealth = errorResponse?.data;
          } else {
            Vue.$log.error(e);
            this.healthError = e;
          }
        }
        this.isLoading = false;
      },
      async loadAbout() {
        this.isLoading = true;
        try {
          const response = await this.$service.api.core.app.getAbout();
          this.appAbout = response;
        } catch (e) {
          this.aboutError = e;
          Vue.$log.error(e);
        }
        this.isLoading = false;
      },
    },
  });
</script>
